export const cookieIdentifier = {
    USER_SESSION        :   'session'   ,   // holds session tokens
    USER_INFO           :   'user'      ,   // holds user information and integrations
    USER_SUBSCRIPTION   :   'subscription', // holds user subscription information
};